/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The McAnswerTranslationParam model module.
 * @module model/McAnswerTranslationParam
 * @version 1.0
 */
class McAnswerTranslationParam {
    /**
     * Constructs a new <code>McAnswerTranslationParam</code>.
     * @alias module:model/McAnswerTranslationParam
     */
    constructor() { 
        
        McAnswerTranslationParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>McAnswerTranslationParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/McAnswerTranslationParam} obj Optional instance to populate.
     * @return {module:model/McAnswerTranslationParam} The populated <code>McAnswerTranslationParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new McAnswerTranslationParam();

            if (data.hasOwnProperty('answer')) {
                obj['answer'] = ApiClient.convertToType(data['answer'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} answer
 */
McAnswerTranslationParam.prototype['answer'] = undefined;






export default McAnswerTranslationParam;

